<!-- Drawn on NavIcon's own 16-grid/1.7-stroke/butt-cap/miter-join hand, so a loan card reads as the same icon family as the sidebar. -->
<script setup lang="ts">
import type { LoanType } from '../internal/types.ts'

defineProps<{ loanType: LoanType | undefined }>()
</script>

<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    aria-hidden="true"
    class="block shrink-0"
    fill="none"
    stroke="currentColor"
    stroke-width="1.7"
    stroke-linecap="butt"
    stroke-linejoin="miter"
  >
    <g v-if="loanType === 'MORTGAGE'">
      <path d="M2 8 8 2 14 8" />
      <path d="M4 8v6h8V8" />
    </g>
    <g v-else-if="loanType === 'CAR'">
      <path d="M2.2 11.4V8.6l1.6-3.8h8.4l1.6 3.8v2.8z" />
      <path d="M2.2 8.6h11.6" />
      <circle cx="5" cy="11.8" r="1.1" />
      <circle cx="11" cy="11.8" r="1.1" />
    </g>
    <g v-else-if="loanType === 'STUDENT'">
      <path d="M8 3 14 6 8 9 2 6Z" />
      <path d="M4.8 7.2v2.6c0 1 1.4 2 3.2 2s3.2-1 3.2-2V7.2" />
      <path d="M13.2 6.6v3.2" />
    </g>
    <g v-else>
      <path d="M12.6 3.4 3.4 12.6" />
      <circle cx="4.6" cy="4.6" r="1.8" />
      <circle cx="11.4" cy="11.4" r="1.8" />
    </g>
  </svg>
</template>
